<div class="main-container">
  <div class="content-container">
    <app-canal-datos></app-canal-datos>
  </div>
</div>


